import { ReactNode, useContext, useEffect, useState } from "react";

interface CRSP
{
    children ?: ReactNode;
    onMouseDown ?: (e: MouseEvent) => void;
    onMouseUp ?: (e: MouseEvent) => void;
}

export function CRS (props: CRSP)
{
    const [visible, setVisible] = useState(0);

    const onMouseMove = (e : MouseEvent) => 
    {
        const cursor : HTMLElement|null = document.querySelector(".mcs");
        if (cursor !== null)
        {
            cursor.style.left = `${e.pageX}px`;
            cursor.style.top = `${e.pageY}px`;
        }
    };

    const onScroll = (e : Event) => { };

    const onMouseDown = (e : MouseEvent) =>
    {
        if (e.button == 0 && props.onMouseDown !== undefined)
            props.onMouseDown(e);
        onMouseMove(e);
    };

    const onMouseUp = (e : MouseEvent) =>
    {
        if (e.button == 0)
        {
            if (props.onMouseUp !== undefined)
                props.onMouseUp(e);
            onMouseMove(e);
        }
    };

    const onMouseOut = (e : MouseEvent) =>
    {
        setVisible(visible + 1);
    };

    const onMouseEnter = (e : MouseEvent) =>
    {
        setVisible(visible - 1);
    };

    const init = () => 
    {
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseover", onMouseMove);
        document.addEventListener("drag", onMouseMove);
        document.addEventListener("dragend", onMouseMove);
        document.addEventListener("scroll", onScroll);
        document.addEventListener("mouseenter", onMouseEnter);
        document.addEventListener("mouseleave", onMouseOut);
        document.addEventListener("mouseup", onMouseUp);
    };

    useEffect(() => {
        init();
        return () => {
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseover", onMouseMove);
            document.removeEventListener("drag", onMouseMove);
            document.removeEventListener("dragend", onMouseMove);
            document.removeEventListener("scroll", onScroll);
            document.removeEventListener("mouseenter", onMouseEnter);
            document.removeEventListener("mouseleave", onMouseOut);
            document.removeEventListener("mouseup", onMouseUp);
        }
    }, [props]);

    return (
        <div className='mcs'>
            { visible <= 0 && props.children !== undefined ? props.children : null }
        </div>
    );
}